import React from 'react';
import { Home, ShoppingCart, Baby, Dog, MoreHorizontal } from 'lucide-react';

const ICONS = { Home, ShoppingCart, Baby, Dog, MoreHorizontal };

export default function CategoryIcon({ iconName, className, size }) {
  const Icon = ICONS[iconName] || MoreHorizontal;
  return <Icon className={className} size={size} />;
}
